import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import estilos from '../../Tabs/TabsInspeccionarComponent.module.css'
import EditIcon from '@mui/icons-material/Edit';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import { useContext } from 'react';
import InspectorEnCampoContext from '../../../Context/InspectorEnCampoContext';
import { getanexoByIdInforme } from '../../../../../redux/DucksUnidadInspeccion/Fi25anexoDuck';
import { insertFotoGaleria } from '../../../../../redux/DucksUnidadInspeccion/FotogaleriaDuck';
import { ReactNotifications } from 'react-notifications-component'
import { Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import SeccionFotogaleriaComponent from './SeccionFotogaleriaComponent';

function FotoFaleriaAlmacenComponent(props) {

    const dispatch = useDispatch();

    const { fotoGaleriaContext, setContextFotoGaleria } = useContext(InspectorEnCampoContext);

    const [isContext, setIsContext] = React.useState(false);

    const [fotosAlmacenProductoTerminado, setfotosAlmacenProductoTerminado] = React.useState([]);
    const [fotosEquipoCarga, setfotosEquipoCarga] = React.useState([]);
    const [fotosAlmacenMaduracion, setfotosAlmacenMaduracion] = React.useState([]);
    const [fotosRecipientes, setfotosRecipientes] = React.useState([]);

    //AREAS DIVERSAS
    const [fotosLaboratorio, setFotosLaboratorio] = React.useState([]);
    const [fotosSanitarios, setFotosSanitarios] = React.useState([]);
    const [fotosEstacionamiento, setFotosEstacionamiento] = React.useState([]);
    const [fotosOficinas, setFotosOficinas] = React.useState([]);
    const [fotosCarga, setFotosCarga] = React.useState([]);
    const [fotosOtros, setFotosOtros] = React.useState([]);

    const todo = props.todo;
    const idinforme = props.idinforme;
    const idanexo = useSelector(store => store.anexo.anexo);
    const instalacion = props.instalacion - 1;

    React.useEffect(() => {
        if (idinforme?.idfi_25_informecumplimientonom) {
            dispatch(getanexoByIdInforme(idinforme.idfi_25_informecumplimientonom)) //informe
        }
        if (fotoGaleriaContext != null) {
            setfotosAlmacenProductoTerminado(fotoGaleriaContext.fotosAlmacenProductoTerminado)
            setfotosEquipoCarga(fotoGaleriaContext.fotosEquipoCarga)
            setfotosAlmacenMaduracion(fotoGaleriaContext.fotosAlmacenMaduracion)
            setfotosRecipientes(fotoGaleriaContext.fotosRecipientes)

            setFotosLaboratorio(fotoGaleriaContext.fotosLaboratorio)
            setFotosSanitarios(fotoGaleriaContext.fotosSanitarios)
            setFotosEstacionamiento(fotoGaleriaContext.fotosEstacionamiento)
            setFotosOficinas(fotoGaleriaContext.fotosOficinas)
            setFotosCarga(fotoGaleriaContext.fotosCarga)
            setFotosOtros(fotoGaleriaContext.fotosOtros)
            setIsContext(true)
        }
    }, [])

    React.useEffect(() => {
        const data = {
            fotosAlmacenProductoTerminado: fotosAlmacenProductoTerminado,
            fotosEquipoCarga: fotosEquipoCarga,
            fotosAlmacenMaduracion: fotosAlmacenMaduracion,
            fotosRecipientes: fotosRecipientes,
            fotosLaboratorio: fotosLaboratorio,
            fotosSanitarios: fotosSanitarios,
            fotosEstacionamiento: fotosEstacionamiento,
            fotosOficinas: fotosOficinas,
            fotosCarga: fotosCarga,
            fotosOtros: fotosOtros,
            submit: true
        }

        setContextFotoGaleria(data)

    }, [fotosAlmacenProductoTerminado, fotosEquipoCarga, fotosAlmacenMaduracion, fotosRecipientes, fotosLaboratorio, fotosSanitarios, fotosEstacionamiento, fotosOficinas, fotosCarga, fotosOtros]);


    const handleAlmacenProductoTerminado = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosAlmacenProductoTerminado([...fotosAlmacenProductoTerminado, event.target.files[0]]);
        }
    }
    const handleEquipoCarga = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosEquipoCarga([...fotosEquipoCarga, event.target.files[0]]);
        }
    }
    const handleAlmacenMaduracion = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosAlmacenMaduracion([...fotosAlmacenMaduracion, event.target.files[0]]);
        }
    }
    const handleRecipientes = (event) => {
        if (event.target.files[0] != undefined) {
            setfotosRecipientes([...fotosRecipientes, event.target.files[0]]);
        }
    }

    //

    const handleLaboratorio = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosLaboratorio([...fotosLaboratorio, event.target.files[0]]);
        }
    }
    const handleSanitarios = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosSanitarios([...fotosSanitarios, event.target.files[0]]);
        }
    }
    const handleEstacionamiento = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosEstacionamiento([...fotosEstacionamiento, event.target.files[0]]);
        }
    }
    const handleOficinas = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosOficinas([...fotosOficinas, event.target.files[0]]);
        }
    }
    const handleCarga = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosCarga([...fotosCarga, event.target.files[0]]);
        }
    }
    const handleOtros = (event) => {
        if (event.target.files[0] != undefined) {
            setFotosOtros([...fotosOtros, event.target.files[0]]);
        }
    }


    return (
        <Fragment>
            <Formik
                initialValues={{}}
                validate={(valores) => {

                    const data = {
                        fotosAlmacenProductoTerminado: fotosAlmacenProductoTerminado,
                        fotosEquipoCarga: fotosEquipoCarga,
                        fotosAlmacenMaduracion: fotosAlmacenMaduracion,
                        fotosRecipientes: fotosRecipientes,
                        fotosLaboratorio: fotosLaboratorio,
                        fotosSanitarios: fotosSanitarios,
                        fotosEstacionamiento: fotosEstacionamiento,
                        fotosOficinas: fotosOficinas,
                        fotosCarga: fotosCarga,
                        fotosOtros: fotosOtros,
                        submit: false
                    }

                    setContextFotoGaleria(data)
                }}
                onSubmit={(valores) => {
                    //console.log(valores)
                }}
            >
                {(props) => (
                    <div className='mt-5'>
                        <hr></hr>
                        <div className='row mb-3'>
                            <label className={`${estilos.labelUI} mb-2`}>ALMACÉN DE PRODUCTO TERMINADO (INTERIOR Y EXTERIOR)</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Almacén de producto terminado (interior y exterior)'} valores={fotosAlmacenProductoTerminado} metodo={handleAlmacenProductoTerminado} />
                            <hr></hr><br /><br />
                            <label className={`${estilos.labelUI} mb-2`}>EQUIPOS DE CARGA (PATÍNES, MONTACARGAS, TARIMAS, ETC,)</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Equipos de carga (patines, montacargas, tarimas, etc.)'} valores={fotosEquipoCarga} metodo={handleEquipoCarga} />
                            <hr></hr><br /><br />
                            <label className={`${estilos.labelUI} mb-2`}>ALMACÉN DE MADURACIÓN (INTERIOR Y EXTERIOR)</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Almacén de maduración (interior y exterior)'} valores={fotosAlmacenMaduracion} metodo={handleAlmacenMaduracion} />
                            <hr></hr><br /><br />
                            <label className={`${estilos.labelUI} mb-2`}>RECIPIENTES DE MADURACIÓN</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Recipientes de maduración'} valores={fotosRecipientes} metodo={handleRecipientes} />
                            <hr></hr><br /><br />
                            <label className={`${estilos.labelUI} mb-2`}>ÁREAS DIVERSAS</label>
                            <SeccionFotogaleriaComponent nombreSeccion={'Laboratorio'} valores={fotosLaboratorio} metodo={handleLaboratorio} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Sanitarios'} valores={fotosSanitarios} metodo={handleSanitarios} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Estacionamiento'} valores={fotosEstacionamiento} metodo={handleEstacionamiento} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Oficinas'} valores={fotosOficinas} metodo={handleOficinas} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Equipo de carga (patines, montacargas)'} valores={fotosCarga} metodo={handleCarga} />
                            <SeccionFotogaleriaComponent nombreSeccion={'Otros'} valores={fotosOtros} metodo={handleOtros} />
                            <hr></hr><br /><br />
                        </div>
                    </div>
                )}
            </Formik>
        </Fragment>
    )
}

export default withRouter(FotoFaleriaAlmacenComponent)